import { acquireBodyScrollLock, releaseBodyScrollLock } from './bodyScrollLock.js';
import { exportHtmlTablesToExcel } from './htmlTableExcel.js';

(function () {
    // Intentionally imported for side effects: SSR preview markup initialises
    // these window.fileviewer* hooks via declarative data-needs-init attributes.
    // Do not remove or refactor away these global bindings.
    function notify(message) {
        if (typeof window.showFlashMessage === 'function') {
            window.showFlashMessage(null, 'warning', message, 5);
            return;
        }
        window.alert(message);
    }

    function setHtmlPreviewReadyState(isReady) {
        var loading = document.getElementById('fileviewer-html-preview-loading');
        var iframe = document.getElementById('fileviewer-html-preview-frame');
        var actions = document.querySelectorAll('[data-preview-action="html"]');

        if (loading) loading.classList.toggle('hidden', isReady);
        if (iframe) iframe.classList.toggle('opacity-0', !isReady);
        actions.forEach(function (button) {
            button.disabled = !isReady;
            button.classList.toggle('opacity-50', !isReady);
            button.classList.toggle('cursor-not-allowed', !isReady);
        });
    }

    var _fileviewerHoldsScrollLock = false;

    window.fileviewerLockBodyScroll = function () {
        if (_fileviewerHoldsScrollLock) return;
        _fileviewerHoldsScrollLock = true;
        acquireBodyScrollLock();
    };

    function unlockBodyScroll() {
        if (!_fileviewerHoldsScrollLock) return;
        _fileviewerHoldsScrollLock = false;
        releaseBodyScrollLock();
    }

    window.fileviewerCloseBackdrop = function (el) {
        if (el.dataset.boundFileviewerCloseBackdrop) return;
        el.dataset.boundFileviewerCloseBackdrop = '1';
        el.addEventListener('click', function () {
            window.closeModal('fileviewer');
            unlockBodyScroll();
        });
    };

    window.fileviewerDownloadFile = function (el) {
        if (el.dataset.boundFileviewerDownload) return;
        el.dataset.boundFileviewerDownload = '1';
        el.addEventListener('click', async function () {
            var filelink = el.getAttribute('data-filelink');
            if (!filelink) { notify('Download failed: no file link provided.'); return; }
            try {
                var res = await fetch(filelink);
                if (!res.ok) { notify('Download failed'); return; }
                var blob = await res.blob();
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.classList.add('hidden');
                a.href = url;
                var rawName = filelink.split('/').pop().split('?')[0];
                var decodedName;
                try { decodedName = decodeURIComponent(rawName); } catch (_e) { decodedName = rawName; }
                a.download = decodedName || 'file';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            } catch (e) {
                notify('Download failed: ' + (e && e.message ? e.message : String(e)));
            }
        });
    };

    window.fileviewerInitHtmlFrame = function (iframe) {
        if (iframe.dataset.boundPreview) return;
        iframe.dataset.boundPreview = '1';
        setHtmlPreviewReadyState(false);
        try {
            var readyState = iframe.contentDocument && iframe.contentDocument.readyState;
            if (readyState === 'complete') {
                setHtmlPreviewReadyState(true);
                return;
            }
        } catch (_e) {}
        iframe.addEventListener('load', function () {
            setHtmlPreviewReadyState(true);
        }, { once: true });
    };

    window.fileviewerExportHtmlPreviewToExcel = function (button) {
        try {
            var iframeId = button && button.getAttribute('data-iframe-id');
            var iframe = iframeId ? document.getElementById(iframeId) : null;
            if (!iframe) { notify('Preview frame not found.'); return; }

            var frameDoc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
            if (!frameDoc || !frameDoc.body) {
                notify('Preview is still loading. Please try again.');
                return;
            }

            var filelink = button.getAttribute('data-filelink') || '';
            var baseName = 'preview';
            if (filelink) {
                try {
                    var parsed = new URL(filelink, window.location.origin);
                    var lastPart = (parsed.pathname.split('/').pop() || '').trim();
                    if (lastPart) baseName = lastPart;
                } catch (_e) {}
            }
            if (!/\.xlsx$/i.test(baseName)) baseName = baseName.replace(/\.[^.]+$/, '') + '.xlsx';

            button.disabled = true;
            button.classList.add('opacity-50', 'cursor-not-allowed');
            // SheetJS is fetched on first use, so re-enable the button when the
            // export settles rather than at the end of this function.
            exportHtmlTablesToExcel(frameDoc.body, baseName)
                .catch(function () {
                    notify('Excel export failed. Please try again.');
                })
                .finally(function () {
                    button.disabled = false;
                    button.classList.remove('opacity-50', 'cursor-not-allowed');
                });
        } catch (error) {
            notify('Excel export failed. Please try again.');
            if (button) {
                button.disabled = false;
                button.classList.remove('opacity-50', 'cursor-not-allowed');
            }
        }
    };

    window.fileviewerPrintHtmlPreview = function (button) {
        try {
            var iframeId = button && button.getAttribute('data-iframe-id');
            var iframe = iframeId ? document.getElementById(iframeId) : null;
            if (!iframe || !iframe.contentWindow) { notify('Preview frame not found.'); return; }
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        } catch (error) {
            notify('Print failed. Please try again.');
        }
    };

    window.fileviewerExcelBtnInit = function (btn) {
        if (btn.dataset.boundFileviewerExcel) return;
        btn.dataset.boundFileviewerExcel = '1';
        btn.addEventListener('click', function () { window.fileviewerExportHtmlPreviewToExcel(btn); });
    };

    window.fileviewerPrintBtnInit = function (btn) {
        if (btn.dataset.boundFileviewerPrint) return;
        btn.dataset.boundFileviewerPrint = '1';
        btn.addEventListener('click', function () { window.fileviewerPrintHtmlPreview(btn); });
    };
})();
